<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Release Project Inventory</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="field">
            <label class="label">Project</label>
            <span>{{ projectInventory.project.project_name }}</span>
          </div>

          <div class="field">
            <label class="label">Product Being Transferred</label>
            <span>{{ projectInventory.inventory.product_master.name }}</span>
          </div>

          <div class="field">
            <label class="label">Quantity Available</label>
            <span>{{ projectInventory.qty_available -  qty}}</span>
          </div>

          <div class="field">
            <label class="label">Transfer Quantity*</label>
            <v-text-field
              required
              placeholder="Enter Transfer Quantity"
              type="number"
              :rules="transferQtyRules"
              v-model="qty">
            </v-text-field>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="transfer()">
            Confirm Transfer
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    projectInventory: {
      type: Object
    }
  },
  components: { 
    VForm,
    VTextField
  },
  data() {
    return {
      qty: null,
      valid: false
    }
  },
  computed: {
    ...mapState("projects", ["projects"]),
    transferQtyRules() {
      return [
        (v) => v <= this.projectInventory.qty_available || 'Transfer quantity cannot be greater than quantity available'
      ]
    }
  },
  methods: {
    ...mapActions("inventoryProject", ["transferToInventory"]),
    transfer() {
      this.transferToInventory({
        from_project_id: this.projectInventory.project.id,
        stocking_unit_id: this.projectInventory.inventory.stocking_unit_id,
        qty: this.qty
      }).then(() => this.close(true))
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>
